// Chats
import Chats from './views/chats/Chat'

// Contacts
import AddContact from './views/contacts/AddContact'
import EditContact from './views/contacts/EditContact'
import ContactList from './views/contacts/ContactList'
import ContactDetails from './views/contacts/ContactDetails'

// Templates
import Templates from './views/templates/SendTemplates'

const routes = [
  { path: '/chat', name: 'Chat', element: Chats, exact: true },
  { path: '/template', name: 'Template', element: Templates, exact: true },
  { path: '/contacts', name: 'Contacts', element: ContactList, exact: true },
  { path: '/contacts/add', name: 'Add Contact', element: AddContact, exact: true},
  { path: '/contacts/edit/:id', name: 'Edit Contact', element: EditContact, exact: true},
  { path: '/contacts/details/:id', name: 'Contact Details', element: ContactDetails, exact: true}
]

export default routes
